import { render, staticRenderFns } from "./ClientsForm.vue?vue&type=template&id=5332a744"
import script from "./ClientsForm.vue?vue&type=script&lang=js"
export * from "./ClientsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports